import React, { Fragment, ReactNode } from 'react'
import { variantTypes } from '@mission.io/question-toolkit'
import { QuestionProps as _QuestionProps } from '@mission.io/question-views'

import FreeResponse from './free-response/FreeResponse'
import MultipleChoice from './multiple-choice/MultipleChoice'
import MultipleSelect from './multiple-select/MultipleSelect'
import ClozeDropdown from './cloze-dropdown/ClozeDropdown'
import ImageLabeling from './image-labeling/ImageLabeling'

export type StudentQuestionProps = _QuestionProps.ForStudent
export type TeacherQuestionProps = _QuestionProps.ForTeacher

export type QuestionProps = TeacherQuestionProps & StudentQuestionProps

export const Question = (
	props: StudentQuestionProps | TeacherQuestionProps
): ReactNode => {
	const { question } = props

	// Student Question View sends an answer message to the server.
	const _sendMessage = (answer: any) => {
		const { sendMessage, requestId } = props as StudentQuestionProps

		if (sendMessage && question) {
			sendMessage({
				questionId: String(question._id),
				requestId: requestId,
				answer,
			})
		}
	}

	if (question)
		switch (question.type) {
			case variantTypes.FREE_RESPONSE:
				return (
					<FreeResponse
						{...props}
						question={question}
						sendMessage={_sendMessage}
					/>
				)
			case variantTypes.MULTIPLE_CHOICE:
				return (
					<MultipleChoice
						{...props}
						question={question}
						sendMessage={_sendMessage}
					/>
				)
			case variantTypes.MULTIPLE_SELECT:
				return (
					<MultipleSelect
						{...props}
						question={question}
						sendMessage={_sendMessage}
					/>
				)
			case variantTypes.CLOZE_DROPDOWN:
				return (
					<ClozeDropdown
						{...props}
						question={question}
						sendMessage={_sendMessage}
					/>
				)
			case variantTypes.IMAGE_LABELING:
				return (
					<ImageLabeling
						{...props}
						question={question}
						sendMessage={_sendMessage}
					/>
				)
			default:
				return <Fragment />
		}
	else return <Fragment />
}

export default Question
